import HyperLinkCell from './HyperLink';

export const DATAGRIDCONSTANTS = {
    header: {
        Document: 130,
        SalesEntity: 50,
        Entered: 87,
        UserId: 65,
        Expiry: 87,
        Description: 291,
        DeliveryName: 291,
    }
};

export const columns = [
    {
        dataField: 'DocumentNumber',
        caption: 'Document no',
        width: DATAGRIDCONSTANTS.header.Document,
        allowSorting: false,
        cellComponent: HyperLinkCell,
    },
    {
        dataField: 'Entity',
        caption: 'Entity',
        width: DATAGRIDCONSTANTS.header.SalesEntity,
        allowSorting: false,
        allowResizing: false,
    },
    {
        dataField: 'UserId',
        caption: 'User ID',
        width: DATAGRIDCONSTANTS.header.UserId,
        allowSorting: false,
        allowEditing: false,
        allowResizing: true,
    },
    {
        dataField: 'EnteredDate',
        caption: 'Entered',
        width: DATAGRIDCONSTANTS.header.Entered,
        allowSorting: false,
        alignment: 'center',
        allowResizing: false,
    },
    {
        dataField: 'ExpiryDate',
        caption: 'Expiry',
        width: DATAGRIDCONSTANTS.header.Expiry,
        allowSorting: false,
        allowEditing: false,
        alignment: 'center',
        allowResizing: false,
    },
    {
        dataField: 'Description',
        caption: 'Description',
        width: DATAGRIDCONSTANTS.header.Description,
        allowSorting: false,
        isEditable: false,
        allowResizing: true,
    },
    {
        dataField: 'Name',
        caption: 'Name',
        width: DATAGRIDCONSTANTS.header.DeliveryName,
        allowSorting: false,
        isEditable: false,
        allowResizing: true,
    },
];
